import Vue from 'vue';
import 'babel-polyfill';
import 'lodash';
import 'current-script-polyfill';

import App from './App.vue';
import store from '@/store';
import router from './routes/router';

import axios from 'axios';
import http from './plugins/http.js';
Vue.prototype.$http = http;
Vue.prototype.$axios = axios;

import './plugins/xss.js';
import './plugins/element.js';
import './plugins/system.js';
import './plugins/modal.js';
import './plugins/wwLogin-1.0.0.js';
import './plugins/global';

import './assets/css/main.css';
import './assets/theme/default/default.scss';
import './assets/theme/black-and-red/black-and-red.scss';
import './assets/theme/black-and-red2/black-and-red2.scss';
import './assets/theme/orange/orange.scss';
import './interceptors';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
